import axios from "axios";
import router from "@/router";

// const baseUrl = "http://192.168.1.6:8088"
const baseUrl = "https://api.mingpianhezi.zaiguwang.com";

axios.interceptors.request.use((config) => {
  let token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 添加响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response?.data?.code == 401) {
      localStorage.removeItem("token");
      router.push("/login");
    }
    return response.data || response;
  },
  (error) => {
    if (error?.response?.data?.code == 401) {
      localStorage.removeItem("token");
      router.push("/login");
    }
    console.error(error.response);
  }
);

function postJSONData(url, params) {
  return axios.post(url, params, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function postFormData(url, params) {
  let forms = new FormData();
  for (const key in params) {
    forms.append(key, params[key]);
  }
  return axios.post(url, forms, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

// 注销账号
export const userLogOff = (params) => {
  return postJSONData(baseUrl + "/casebox/userLogOff", params);
};

// 手机发送短信验证码
export const getCode = (params) => {
  return postJSONData(baseUrl + "/casebox/getCode", params);
};

// 修改绑定手机号/修改密码 老手机号发送验证码
export const updateTelGetCode = (params) => {
  return axios.get(baseUrl + "/casebox/updateTelGetCode", {
    params: params,
  });
};

// 修改绑定手机号 验证手机号及验证码接口
export const checkTelCode = (params) => {
  return postJSONData(baseUrl + "/casebox/checkTelCode", params);
};

// 换绑手机
export const updateUserTel = (params) => {
  return postJSONData(baseUrl + "/casebox/updateUserTel", params);
};

// 修改密码
export const updateUserPassword = (params) => {
  return postJSONData(baseUrl + "/casebox/updateUserPassword", params);
};

// 手机短信验证码登录
export const loginWithCode = (params) => {
  return postJSONData(baseUrl + "/casebox/loginWithCode", params);
};

// 获取微信登录二维码
export const getQRCodeUrl = (params) => {
  return axios.get(baseUrl + "/casebox/getQRCodeUrl", {
    params: params,
  });
};

// 获取小程序二维码
export const getAppQrCode = (params) => {
  return axios.get(baseUrl + "/casebox/app/getAppQrCode", {
    params: params,
    responseType: "blob",
  });
};

// 获取微信登录信息
export const loginWithQRCode = (params) => {
  return postJSONData(baseUrl + "/casebox/loginWithQRCode", params);
};

// 微信注册绑定
export const loginWithQRCodeRegist = (params) => {
  return postJSONData(baseUrl + "/casebox/loginWithQRCodeRegist", params);
};

// 登录
export const login = (params) => {
  return postJSONData(baseUrl + "login", params);
};

// 退出登录
export const loginOut = (params) => {
  return axios.get(baseUrl + "/casebox/loginOut", {
    params: params,
  });
};

// 获取用户个人二维码
export const getUserQrCode = (params) => {
  return axios.get(baseUrl + "/casebox/getUserQrCode", {
    params: params,
    responseType: "blob",
  });
};

// 查询用户信息
export const getUserInfo = (params) => {
  return axios.get(baseUrl + "/casebox/user/userInfo", {
    params: params,
  });
};

// 用户身份切换
export const updateUserIdentity = (params) => {
  return postJSONData(baseUrl + "/casebox/user/updateUserIdentity", params);
};

// 获取用户首页浏览、分享数
export const userStatic = (params) => {
  return axios.get(baseUrl + "/casebox/user/userStatic", {
    params: params,
  });
};

// 个人资料信息页修改
export const updateUserInfo = (params) => {
  return postJSONData(baseUrl + "/casebox/user/updateUserInfo", params);
};

// 个人上传头像
export const updateUserAvatar = (params) => {
  return postJSONData(baseUrl + "/casebox/updateUserAvatar", params);
};

// 公司/工作室品牌设置
export const companyBrandConfig = (params) => {
  return postFormData(
    baseUrl + "/casebox/companyInfo/companyBrandConfig",
    params
  );
};

// 公司/工作室品牌设置列表
export const companyBrandConfigList = (params) => {
  return axios.get(baseUrl + "/casebox/companyInfo/companyBrandConfigList", {
    params: params,
  });
};

// 企业/工作室员工添加
export const saveCompanyMember = (params) => {
  return postJSONData(
    baseUrl + "/casebox/companyMember/saveCompanyMember",
    params
  );
};

// 企业/工作室员工删除
export const deleteCompanyMember = (params) => {
  return postJSONData(
    baseUrl + "/casebox/companyMember/deleteCompanyMember",
    params
  );
};

// 企业/工作室员工编辑
export const updateCompanyMember = (params) => {
  return postJSONData(
    baseUrl + "/casebox/companyMember/updateCompanyMember",
    params
  );
};

// 企业/工作室员工列表
export const companyMemberList = (params) => {
  return axios.get(baseUrl + "/casebox/companyMember/companyMemberList", {
    params: params,
  });
};

// 用户产品与项目详情
export const userProjectList = (params) => {
  return axios.get(baseUrl + "/casebox/user/userProjectList", {
    params: params,
  });
};

// 荣誉与认证列表
export const userApproveList = (params) => {
  return axios.get(baseUrl + "/casebox/user/userApproveList", {
    params: params,
  });
};

// 用户产品与项目新增
export const addUserProject = (params) => {
  return postJSONData(baseUrl + "/casebox/user/addUserProject", params);
};

// 用户产品与项目编辑
export const updateUserProject = (params) => {
  return postJSONData(baseUrl + "/casebox/user/updateUserProject", params);
};

// 用户产品与项目删除
export const deleteUserProject = (params) => {
  return postJSONData(baseUrl + "/casebox/user/deleteUserProject", params);
};

// 用户荣誉与认证/合作伙伴新增
export const addUserApprove = (params) => {
  return postJSONData(baseUrl + "/casebox/user/addUserApprove", params);
};

// 用户荣誉与认证/合作伙伴编辑
export const updateUserApprove = (params) => {
  return postJSONData(baseUrl + "/casebox/user/updateUserApprove", params);
};

// 用户荣誉与认证/合作伙伴删除
export const deleteUserApprove = (params) => {
  return postJSONData(baseUrl + "/casebox/user/deleteUserApprove", params);
};

// 管理员公司/工作室认证信息列表
export const adminCompanyInfoList = (params) => {
  return axios.get(baseUrl + "/casebox/companyInfo/adminCompanyInfoList", {
    params: params,
  });
};

// 管理员公司信息认证
export const adminCompanyInfoApprove = (params) => {
  return postJSONData(
    baseUrl + "/casebox/companyInfo/adminCompanyInfoApprove",
    params
  );
};

// 上传文件-单个
export const uploadFile = (params) => {
  return postFormData(baseUrl + "/casebox/images/image/upload", params);
};

// 上传文件-单个-另一种上传方式
export const uploadFile2 = (params) => {
  return postFormData(baseUrl + "/casebox/images/image/uploadFile", params);
};

// 转码文件轮询
export const getPrefop = (params) => {
  return axios.get("https://api.qiniu.com/status/get/prefop", {
    params: params,
  });
};

// pdf转图片文件上传 只返回路径
export const uploadPdfGetImage = (params) => {
  return postFormData(baseUrl + "/casebox/images/uploadPdfGetImage", params);
};

// 文件删除
export const deleteFile = (params) => {
  return postJSONData(baseUrl + "/casebox/images/deleteFile", params);
};

// 上传作品详情
export const saveWork = (params) => {
  return postJSONData(baseUrl + "/casebox/work/saveWork", params);
};

// 编辑作品详情
export const updateWork = (params) => {
  return postJSONData(baseUrl + "/casebox/work/updateWork", params);
};

// 删除作品
export const deleteWork = (params) => {
  return postJSONData(baseUrl + "/casebox/work/deleteWork", params);
};

// 获取作品列表
export const getWorkList = (params) => {
  return axios.get(baseUrl + "/casebox/work/list", {
    params: params,
  });
};

// 获取作品详情
export const getWorkInfo = (params) => {
  return axios.get(baseUrl + "/casebox/work/workInfo", {
    params: params,
  });
};

// 获取作品类型列表
export const getWorkType = (params) => {
  return axios.get(baseUrl + "/casebox/workType/list", {
    params: params,
  });
};

// 作品类型保存（单个）
export const saveWorkType = (params) => {
  return postJSONData(baseUrl + "/casebox/workType/save", params);
};

// 作品类型删除（单个）
export const deleteWorkType = (params) => {
  return postJSONData(baseUrl + "/casebox/workType/delete", params);
};

// 获取标签列表
export const getLabelList = (params) => {
  return axios.get(baseUrl + "/casebox/workTag/list", {
    params: params,
  });
};

// 获取公司id
export const getCompanyId = (params) => {
  return axios.get(baseUrl + "/casebox/companyInfo/getCompanyId", {
    params: params,
  });
};

// 标签保存（单个）
export const saveWorkTag = (params) => {
  return postJSONData(baseUrl + "/casebox/workTag/save", params);
};

// 企业/工作室认证信息保存(提交认证信息，管理员审核
export const saveCompanyInfo = (params) => {
  return postJSONData(baseUrl + "/casebox/companyInfo/saveCompanyInfo", params);
};

// 企业/工作室认证信息编辑
export const updateCompanyInfo = (params) => {
  return postJSONData(
    baseUrl + "/casebox/companyInfo/updateCompanyInfo",
    params
  );
};

//  企业/工作室认证信息修改(已认证才能编辑)
export const updateCompany = (params) => {
  return postJSONData(baseUrl + "/casebox/companyInfo/updateCompany", params);
};

// 获取pdf模板列表
export const pdfModelList = (params) => {
  return axios.get(baseUrl + "/casebox/pdf/pdfModelList", {
    params: params,
  });
};

// 获取通告信息列表
export const messageList = (params) => {
  return axios.get(baseUrl + "/casebox/message/messageList", {
    params: params,
  });
};

//  通告已读 批量
export const readMessage = (params) => {
  return postJSONData(baseUrl + "/casebox/message/readMessage", params);
};

// 存储二维码数据
export const saveQrCode = (params) => {
  return postJSONData(baseUrl + "/casebox/pdf/createPdfCode", params);
};
// 获取小程序列表
export const getAppList = (params) => {
  return axios.get(baseUrl + "/casebox/app/webAppList", {
    params: params,
  });
};
// 获取小程序详情
export const getAppInfo = (params) => {
  return axios.get(baseUrl + "/casebox/app/appInfo", {
    params: params,
  });
};
// 保存小程序
export const updateAppInfo = (params) => {
  return postJSONData(baseUrl + "/casebox/app/updateAppInfo", params);
};
// 使用模板
export const useApp = (params) => {
  return postJSONData(baseUrl + "/casebox/app/useApp", params);
};
// 获取小程序二维码
export const getXcxQrCode = (params) => {
  return axios.get(baseUrl + "/casebox/app/getAppQrCode", {
    params: params,
    responseType: 'blob' // 新增这一行，指明期望的响应数据类型
  });
};
// 密码登录
export const passwordLogin = (params) => {
  return postJSONData(baseUrl + "/casebox/login", params);
};
// 用户产品与项目批量初始化接口
export const addUserProjectBatch = (params) => {
  return postJSONData(baseUrl + "/casebox/user/addUserProjectBatch", params);
};
// 用户荣誉与认证/合作伙伴批量初始化接口
export const addUserApproveBatch = (params) => {
  return postJSONData(baseUrl + "/casebox/user/addUserApproveBatch", params);
};
// 团队成员批量初始化接口
export const saveCompanyMemberBatch = (params) => {
  return postJSONData(baseUrl + "/casebox/companyMember/saveCompanyMemberBatch", params);
};

// 获取七牛云token
export const getQiuniuToken = (params) => {
  return postJSONData("https://crmnew.jisudonghua.com/adminapi/upload/getQiuniuToken", params);
};
// 获取素材
export const userMaterialList = (params) => {
  return axios.get(baseUrl + "/casebox/work/userMaterialList", {
    params: params,
  });
};

// 上传素材
export const uploadMaterial = (params) => {
  return postFormData(baseUrl + "/casebox/images/image/uploadMaterial", params);
};
// 删除素材
export const deleteUserMaterial = (params) => {
  return postJSONData(baseUrl + "/casebox/work/deleteUserMaterial", params);
};